<template>
	<div
		v-if="badge"
		class="badge-display-page py-5"
	>
		<div class="container">
			<div class="row">
				<div class="col-md-3">
					<div class="badge-display-left p-4 text-center">
						<img
							class="badge-img mb-5"
							:src="
								badge
									? `${$laravel.novaUploadsFolder}/${badge.logo_image}`
									: null
							"
							alt=""
							srcset=""
						>
						<div class="badge-display-left__info text-left mb-4">
							<h1>
								Délivré à {{ badge.user.firstname + " " + badge.user.lastname }}
							</h1>
							<h1>Le {{ badge.issued_on }}</h1>
							<h1>PAR JOBREADY</h1>
						</div>
						<img
							class="open-badge-logo"
							src="https://openbadgepassport.com/img/extra/passport/verifiedissuedbyobf.png"
							alt="Open Badge Logo"
						>
					</div>
				</div>
				<div class="col-md-9">
					<div class="j_card">
						<div class="border-bottom-light py-3">
							<h1
								v-if="badge.evaluatorsCount === 0"
								class="j_card-title"
							>
								{{ badge.skill.name }} ¦ AUTOÉVALUÉE
							</h1>
							<h1
								v-else-if="badge.level >= 1"
								class="j_card-title"
							>
								{{ badge.skill.name }} ¦
								{{
									badge.evaluatorsCount > 1
										? `RECONNUE PAR ${badge.evaluatorsCount} PERSONNES`
										: "RECONNUE PAR UNE PERSONNE"
								}}
							</h1>
							<p class="mt-5">
								Ce badge numérique atteste que
								{{ badge.user.firstname + " " + badge.user.lastname }} a bien
								mobilisé la compétence {{ badge.skill.name }} :
								{{ badge.skill.description }}
							</p>
							<p>
								Il a été délivré dans le cadre du parcours <router-link
									class="j_font-color-base text-decoration-underline"
									:to="{ name: 'comment_ca_marche' }"
								>
									Jobready
								</router-link>
							</p>
						</div>
						<div class="border-bottom-light py-5">
							<h1 class="j_card-title">
								Preuves
							</h1>
							<div class="row mt-5">
								<div class="col-md-6">
									<p>
										{{ badge.user.firstname + " " + badge.user.lastname }} a
										mobilisé cette compétence dans :
									</p>
									<ul class="list-decorate">
										<li v-if="badge.volunteerExperiencesCount > 0">
											{{ badge.volunteerExperiencesCount }} expérience{{
												badge.volunteerExperiencesCount > 1 ? "s" : ""
											}}
											d’engagement
										</li>
										<li v-if="badge.personalExperiencesCount > 0">
											{{ badge.personalExperiencesCount }} expérience{{
												badge.personalExperiencesCount > 1 ? "s" : ""
											}}
											personnelle{{
												badge.personalExperiencesCount > 1 ? "s" : ""
											}}
										</li>
										<li v-if="badge.proExperiencesCount > 0">
											{{ badge.proExperiencesCount }} expérience{{
												badge.proExperiencesCount > 1 ? "s" : ""
											}}
											professionnelle{{
												badge.proExperiencesCount > 1 ? "s" : ""
											}}
										</li>
										<li v-if="badge.scholarExperiencesCount > 0">
											{{ badge.scholarExperiencesCount }} expérience{{
												badge.scholarExperiencesCount > 1 ? "s" : ""
											}}
											scolaire{{ badge.scholarExperiencesCount > 1 ? "s" : "" }}
										</li>
									</ul>
								</div>
								<div
									v-if="badge.evaluatorsCount > 0"
									class="col-md-6"
								>
									<p>
										{{ badge.evaluatorsCount }} personne{{ badge.evaluatorsCount > 1 ? "s ont évalué" : " a évalué" }}
										{{ badge.user.firstname + " " + badge.user.lastname }} selon
										4 critères dont :
									</p>
									<ul class="list-decorate">
										<template v-for="(count, fonction) in badge.evaluatorsCountByFonction">
											<li
												v-if="count > 0"
												:key="fonction"
											>
												{{ count }} {{ fonction }}{{ count > 1 ? "s" : "" }}
											</li>
										</template>
									</ul>
								</div>
							</div>
						</div>
						<div class="border-bottom-light py-5">
							<h1 class="j_card-title">
								Critères D’ÉVALUATION
							</h1>
							<div class="row align-items-center">
								<div
									v-for="(question, index) in badge.skill.questions"
									:key="question.id"
									class="col-md-6"
								>
									<div class="d-flex align-items-center gap-2 mt-5">
										<div class="question__index">
											{{ index + 1 }}.
										</div>
										<div class="question__text">
											{{ question.question }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="py-5">
							<p class="font-italic">
								Pour en savoir plus sur les soft skills, rendez-vous sur
								<router-link
									class="j_font-color-base text-decoration-underline"
									:to="{ name: 'soft_skills' }"
									target="_blank"
								>
									notre page dédiée
								</router-link>.
							</p>
							<p class="font-italic">
								Découvrir l'ensemble du référentiel soft skills de Jobready en
								un coup d’œil sur ce
								<a
									class="j_font-color-base text-decoration-underline"
									target="_blank"
									href="https://www.jobready.fr/documents/soft-skills-référentiel.pdf"
									rel="noopener noreferrer"
								>lien</a>.
							</p>
							<template v-if="badgeHasEndosors">
								<p class="mt-5">
									Les badges Jobready sont endossés par les entreprises suivantes
									:
								</p>
								<div
									class="
								                  badge-endorsors
								                  d-flex
								                  align-items-center
								                  justify-content-center
								                  gap-2
								                "
								>
									<img v-for="endorsor in badge.endorsors" :key="endorsor.id" :src="`${$laravel.novaUploadsFolder}/${endorsor.logo}`" :alt="endorsor.name">
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DataLayerPush from '_components/mixins/dataLayerPush';

export default {
  mixins: [DataLayerPush],
  data() {
    return {
      badge: null,
      checkBagde: false,
    };
  },

  computed: {
    totalEvaluator() {
      return this.badge.pairCount + this.badge.referentCount;
    },
    badgeHasEndosors() {
      if (this.badge && this.badge.endorsors && this.badge.endorsors.length > 0) {
        return true;
      }
      return false;
    },
  },

  created() {
    this.getBadge();
  },

  mounted() {
    this.eventTrackGtaData('Afficheur Badges', this.$route.fullPath);
  },

  methods: {
    async getBadge() {
      this.badgesLoading = true;
      try {
        const response = await axios.get(`/api/badge/${this.$route.params.id}`);
        this.badge = response.data;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.error(error);
          this.$router.replace({ name: 'notFound', params: { catchAll: '*' } });
        } else {
          console.error(error);
        }
      } finally {
        this.badgesLoading = false;
        this.redirectToUuid();
      }
    },
    redirectToUuid() {
      return this.$router.replace({ name: 'badgeId', params: { id: this.badge.uuid } });
    },
    isValidUUID(input) {
      // UUID regex pattern
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return typeof input === 'string' && uuidRegex.test(input);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "_sass/_global.scss";
@import "_sass/base/_mixins.scss";

.badge-display-page {
	background: #f9f9f9;
	min-height: 100vh;
}

.badge-display-left {
	background: $white;
	border-radius: 5px 100px 5px 5px;
}

.badge-img {
	width: 175px;
	height: 175px;
	object-fit: contain;
}

.badge-display-left__info h1 {
	font-family: $font-family-bebas;
	font-style: normal;
	font-weight: 400;
	font-size: 30px;
	line-height: 36px;
	text-transform: uppercase;
	color: #353535;
}

.question__index {
	font-family: "bebas", "Arial", "Helvetica Neue", "Helvetica", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 74px;
	line-height: 70px;
	text-transform: uppercase;
	color: $primary;
}
</style>
